import React, { useState, useEffect } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import { Container, Row, Col, FormGroup, Button } from 'reactstrap';
import './SingleCalenderView.css';
import { SingleSelect } from '../CommonComponents';
import {
  fetchUserLoginHistoryMonthWise,
  getHolidayList,
} from '../../constants/apiCalls';
import ModalService from '../../services/ModalService';
import { handleErrorMessage } from '../../utils/utils';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';

const localizer = momentLocalizer(moment);

const SingleCalenderView = ({ user, setDate, currDate, setLoading }) => {
  function handleEventPropGetter(e) {
    const backgroundColor = 'transparent';
    const color = e.type ? 'green' : 'red';
    const outline = 'none';
    return {
      style: { backgroundColor, color, outline },
    };
  }

  const handleEventClick = (e) => {};

  const monthArr = [
    { id: 1, monthName: 'January' },
    { id: 2, monthName: 'February' },
    { id: 3, monthName: 'March' },
    { id: 4, monthName: 'April' },
    { id: 5, monthName: 'May' },
    { id: 6, monthName: 'June' },
    { id: 7, monthName: 'July' },
    { id: 8, monthName: 'August' },
    { id: 9, monthName: 'September' },
    { id: 10, monthName: 'October' },
    { id: 11, monthName: 'November' },
    { id: 12, monthName: 'December' },
  ];

  const yearArr = [
    {
      id: new Date().getFullYear() - 11,
      yearName: new Date().getFullYear() - 11,
    },
    {
      id: new Date().getFullYear() - 10,
      yearName: new Date().getFullYear() - 10,
    },
    {
      id: new Date().getFullYear() - 9,
      yearName: new Date().getFullYear() - 9,
    },
    {
      id: new Date().getFullYear() - 8,
      yearName: new Date().getFullYear() - 8,
    },
    {
      id: new Date().getFullYear() - 7,
      yearName: new Date().getFullYear() - 7,
    },
    {
      id: new Date().getFullYear() - 6,
      yearName: new Date().getFullYear() - 6,
    },
    {
      id: new Date().getFullYear() - 5,
      yearName: new Date().getFullYear() - 5,
    },
    {
      id: new Date().getFullYear() - 4,
      yearName: new Date().getFullYear() - 4,
    },
    {
      id: new Date().getFullYear() - 3,
      yearName: new Date().getFullYear() - 3,
    },
    {
      id: new Date().getFullYear() - 2,
      yearName: new Date().getFullYear() - 2,
    },
    {
      id: new Date().getFullYear() - 1,
      yearName: new Date().getFullYear() - 1,
    },
    { id: new Date().getFullYear(), yearName: new Date().getFullYear() },
    {
      id: new Date().getFullYear() + 1,
      yearName: new Date().getFullYear() + 1,
    },
    {
      id: new Date().getFullYear() + 2,
      yearName: new Date().getFullYear() + 2,
    },
    {
      id: new Date().getFullYear() + 3,
      yearName: new Date().getFullYear() + 3,
    },
    {
      id: new Date().getFullYear() + 4,
      yearName: new Date().getFullYear() + 4,
    },
    {
      id: new Date().getFullYear() + 5,
      yearName: new Date().getFullYear() + 5,
    },
    {
      id: new Date().getFullYear() + 6,
      yearName: new Date().getFullYear() + 6,
    },
    {
      id: new Date().getFullYear() + 7,
      yearName: new Date().getFullYear() + 7,
    },
    {
      id: new Date().getFullYear() + 8,
      yearName: new Date().getFullYear() + 8,
    },
    {
      id: new Date().getFullYear() + 9,
      yearName: new Date().getFullYear() + 9,
    },
    {
      id: new Date().getFullYear() + 10,
      yearName: new Date().getFullYear() + 10,
    },
  ];

  const [monthId, setMonthId] = useState(moment(currDate).month() + 1);
  const [yearId, setYearId] = useState(moment(currDate).year());

  const [activeDays, setActiveDays] = useState([]);
  const [inactiveDays, setInctiveDays] = useState([]);

  const [holidays, setHolidays] = useState([]);

  const handleNavigate = (date) => {
    setMonthId(moment(date).month() + 1);
    setYearId(moment(date).year());
    setDate(moment(date));
  };

  useEffect(() => {
    setLoading(true);

    getHolidayList(
      (res) => {
        const { data, success, error } = res;

        if (success) {
          setHolidays(data);
        } else if (success === false || success === 'undefined') {
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
      },
      {
        month: monthId,
        year: yearId,
        q: '',
        pagesize: 10000,
        page: 1,
      },
    );

    fetchUserLoginHistoryMonthWise(
      (res) => {
        const { data, success, error } = res;

        if (success) {
          setLoading(false);

          setActiveDays(data[0].activedays || []);
          setInctiveDays(data[0].inactivedays || []);
        } else if (success === false || success === 'undefined') {
          setLoading(false);

          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
      },
      {
        month: monthId,
        year: yearId,
        id: user.id,
      },
    );
  }, [monthId, yearId]);

  const customDayPropGetter = (dayInfo) => {
    if (moment(currDate).format('LL') === moment(dayInfo).format('LL')) {
      if (activeDays.includes(moment(dayInfo).format('YYYY-MM-DD'))) {
        return {
          style: {
            backgroundColor: '#7BFF7B',
            border: '2px solid #006BFF',
            borderRadius: '10px',
          },
        };
      }

      if (inactiveDays.includes(moment(dayInfo).format('YYYY-MM-DD'))) {
        return {
          style: {
            backgroundColor: '#FF8080',
            border: '2px solid #006BFF',
            borderRadius: '10px',
          },
        };
      }
    }

    if (
      holidays &&
      holidays.length > 0 &&
      holidays
        .map((item) => item.date)
        .includes(moment(dayInfo).format('YYYY-MM-DD'))
    ) {
      return {
        style: { backgroundColor: '#ffc107' },
      };
    }

    if (activeDays.includes(moment(dayInfo).format('YYYY-MM-DD'))) {
      return {
        style: { backgroundColor: '#7BFF7B' },
      };
    }

    if (inactiveDays.includes(moment(dayInfo).format('YYYY-MM-DD'))) {
      return {
        style: { backgroundColor: '#FF8080' },
      };
    }

    if (moment(dayInfo).month() !== monthId - 1) {
      return {
        style: { backgroundColor: '#E6E6E6' },
      };
    }
  };

  const prevMonth = () => {
    if (monthId === 1) {
      setMonthId(12);
      setDate(
        moment()
          .month(11)
          .year(yearId)
          .date(1),
      );
      return;
    }
    setDate(
      moment()
        .month(monthId - 2)
        .year(yearId)
        .date(1),
    );
    setMonthId(monthId - 1);
  };

  const nextMonth = () => {
    if (monthId === 12) {
      setMonthId(1);

      setDate(
        moment()
          .month(0)
          .year(yearId)
          .date(1),
      );

      return;
    }

    setDate(
      moment()
        .month(monthId)
        .year(yearId)
        .date(1),
    );
    setMonthId(monthId + 1);
  };

  return (
    <>
      <Container className="mt-3 singleCalender">
        <Row>
          <Col xs={12}>
            <span style={{ fontSize: '1.5rem' }}>
              Report of <strong>{user.user_name}</strong> Login History for{' '}
              <strong>{moment(currDate).format('ll')}</strong>
            </span>
          </Col>
        </Row>
        <Row>
          <div className="calender-big-toolbar">
            <div className="nextPrevCalenderBtn" onClick={prevMonth}>
              <FiArrowLeft size="26px" color="#7898CE" />
            </div>
            <div className="todayContainer">
              <Button
                color="primary"
                style={{ marginTop: '-25px', marginRight: '1rem' }}
                onClick={() => {
                  setDate(moment(Date.now()));
                  setMonthId(moment(Date.now()).month() + 1);
                  setYearId(moment(Date.now()).year());
                }}
              >
                Today
              </Button>
              <FormGroup>
                <SingleSelect
                  id="month"
                  name="month"
                  value={
                    monthId === null || monthId === 'undefined' ? '' : monthId
                  }
                  onChange={(e) => {
                    setDate(
                      moment()
                        .month(e.target.value - 1)
                        .year(yearId)
                        .date(1),
                    );
                    setMonthId(e.target.value);
                  }}
                  options={monthArr}
                  label={'monthName'}
                  selectedValueKey={'id'}
                />
              </FormGroup>
              <FormGroup style={{ marginLeft: '1rem' }}>
                <SingleSelect
                  id="year"
                  name="year"
                  value={
                    yearId === null || yearId === 'undefined' ? '' : yearId
                  }
                  onChange={(e) => {
                    setDate(
                      moment()
                        .month(monthId - 1)
                        .year(e.target.value)
                        .date(1),
                    );
                    setYearId(e.target.value);
                  }}
                  options={yearArr}
                  label={'yearName'}
                  selectedValueKey={'id'}
                />
              </FormGroup>
            </div>
            <div className="nextPrevCalenderBtn" onClick={nextMonth}>
              <FiArrowRight size="26px" color="#7898CE" />
            </div>
          </div>
        </Row>
        <Row>
          <Col xs={12}>
            <Calendar
              onNavigate={handleNavigate}
              localizer={localizer}
              onSelectEvent={handleEventClick}
              eventPropGetter={handleEventPropGetter}
              dayPropGetter={customDayPropGetter}
              views={['month']}
              toolbar={false}
              date={currDate}
              style={{ height: 500 }}
            />
          </Col>
        </Row>
        <Row>
          <div className="colorReference">
            <div>
              <div style={{ backgroundColor: '#7BFF7B' }}></div>
              <p>Active Days</p>
            </div>
            <div>
              <div style={{ backgroundColor: '#FF8080' }}></div>
              <p>In-Active Days</p>
            </div>
            <div>
              <div style={{ backgroundColor: '#ffc107' }}></div>
              <p>Holidays</p>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default SingleCalenderView;
